module.exports = __webpack_public_path__ + "img/search.dfc080bf.svg";